import React, { useEffect, useState } from 'react';
import './css/index.scss';
import MyModal from '../../../../components/MyModal';
import MyButton from '../../../../components/MyButton';
import sendRequest from '../../../../helpers/sendRequest';
import Api from '../../../../Api';
import { KEYWORDS_MODAL_STATES } from '../../constants';
import { formatKeywords, parseKeywords } from '../../helpers/keywords';

function KeywordsModal({
  isVisible,
  setIsVisible,
  modalState,
  selectedCountry = {},
  selectedCity = {},
  setSelectedCity,
}) {
  const [keywordsText, setKeywordsText] = useState('');
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);

  const entityName = modalState === KEYWORDS_MODAL_STATES.country
    ? selectedCountry.name
    : selectedCity.name;

  const entityId = modalState === KEYWORDS_MODAL_STATES.country
    ? selectedCountry._id
    : selectedCity._id;

  const closeModal = () => {
    if (loading || fetchLoading) return;

    setIsVisible(false);
    setTimeout(() => {
      setKeywordsText('');
      setSelectedCity({});
    }, 400);
  };

  const fetchKeywords = async () => {
    if (!entityId) return;

    const request = modalState === KEYWORDS_MODAL_STATES.country
      ? Api.getCountryKeywords
      : Api.getCityKeywords;

    const data = await sendRequest({
      request,
      payload: entityId,
      warnErrorText: 'while getting keywords',
      setLoading: setFetchLoading,
    });

    if (data?.status === 'ok') {
      setKeywordsText(formatKeywords(data.keywords));
    }
  };

  const onSaveClick = async () => {
    const keywords = parseKeywords(keywordsText);

    const request = modalState === KEYWORDS_MODAL_STATES.country
      ? Api.putCountryKeywords
      : Api.putCityKeywords;

    const data = await sendRequest({
      request,
      payload: { id: entityId, keywords },
      warnErrorText: 'while saving keywords',
      setLoading,
    });

    if (data?.status === 'ok') {
      closeModal();
    }
  };

  useEffect(() => {
    if (isVisible && entityId) {
      fetchKeywords().then();
    }
  }, [isVisible, entityId, modalState]);

  return (
    <MyModal isOpen={isVisible} closeFunction={closeModal}>
      <div className="countries_keywords_modal">
        <p className="modal_title">Keywords</p>

        <p className="modal_info_name">{entityName}</p>

        <p className="modal_hint">
          Все keywords должны быть с маленькой буквы и разделены запятой с пробелом (", ").
          Пробел без запятой будет считаться частью слова.
        </p>

        <textarea
          className="keywords_modal_textarea"
          value={keywordsText}
          onChange={(e) => setKeywordsText(e.target.value)}
          placeholder="serbia, srbija, rs"
          disabled={fetchLoading}
          rows={6}
          spellCheck={false}
        />

        <div className="modal_buttons_row">
          <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
          <MyButton
            className="modal_button"
            text="Сохранить"
            loading={loading}
            disabled={fetchLoading}
            onClick={onSaveClick}
          />
        </div>
      </div>
    </MyModal>
  );
}

export default KeywordsModal;
